import script from "./AppWrapper.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./AppWrapper.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppWrapper.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0]!./AppWrapper.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__